document.addEventListener("DOMContentLoaded", () => {
  AddToCartText();
  FlavorOption();
  const productRatings = document.querySelector(".questions-tab");

  function showRatings() {
    productRatings.style.visibility = "visible";
  }

  const waitForNavBar = setInterval(function () {
    const navBar = document.querySelector(".oke-w-navBar");
    if (navBar) {
      clearInterval(waitForNavBar);
      setTimeout(showRatings, 2500);
      const questionsTab = document.querySelector("a.questions-tab");
      var tabButtons3 = document.querySelectorAll('div[role="tablist"] button');
      const contentElement = tabButtons3[1].querySelector(
        ".oke-w-navBar-item-count"
      );
      const content = contentElement ? contentElement.textContent : null;

      if (content !== null && typeof content !== "undefined") {
        if (parseInt(content) === 1) {
          questionsTab.innerHTML = content + " Question";
        } else {
          questionsTab.innerHTML = content + " Questions";
        }
      } else {
        questionsTab.innerHTML = "Ask a Question";
      }
    }
  }, 200);
});

document.addEventListener("DOMContentLoaded", function () {
  // Event delegation for opening the popup
  document.addEventListener("click", function (event) {
    if (event.target.classList.contains("popup-link")) {
      event.preventDefault();
      var popup = event.target
        .closest(".popup-container")
        .querySelector(".popup");
      var main = document.querySelector("main");
      if (popup) {
        popup.style.display = "flex";
        document.documentElement.style.overflow = "hidden";
        main.style.zIndex = "700";
      }
    }
  });

  // Event delegation for closing the popup
  document.addEventListener("click", function (event) {
    if (
      event.target.classList.contains("popup-close") ||
      event.target.classList.contains("popup")
    ) {
      var popup = event.target.closest(".popup");
      var main = document.querySelector("main");
      if (
        popup &&
        (event.target.classList.contains("popup-close") ||
          event.target == popup)
      ) {
        popup.style.display = "none";
        document.documentElement.style.overflow = "";
        main.style.zIndex = "500";
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var elem = document
    .querySelectorAll(
      '.options-selection__select-label[data-variant-option-name="Quantity"]'
    )[0]
    .closest(".options-selection__select-wrapper");
  var node = document.querySelectorAll(".product--outer .product-form--atc")[0];

  node.insertAdjacentElement("afterbegin", elem);
});

document.body.addEventListener("click", function (e) {
  if (e.target.closest(".selling_plan_fields")) {
    AddToCartText();
  }
});

document.body.addEventListener("change", function (e) {
  if (e.target.closest(".options-selection__input-select")) {
    AddToCartText();
  }
});

document
  .querySelector("variant-selection")
  .addEventListener("variant-change", function (a) {
    AddToCartText();
  });

function AddToCartText() {
  var copy = "";
  const atcButton = document.querySelector(".atc-button--text");
  const defaultCtaText = atcButton.getAttribute("data-cta-text") || "Add to Cart";

  console.log(
    document.querySelectorAll(
      ".one-time-container.radio-container input:checked"
    ).length,
    " | ",
    document.querySelectorAll(
      ".subscribe_container.radio-container input:checked"
    ).length
  );

  if (
    document.querySelectorAll(
      ".one-time-container.radio-container input:checked"
    ).length
  ) {
    copy = defaultCtaText;
    document.body.setAttribute("plan-choosen", "one_time");
  } else if (
    document.querySelectorAll(
      ".subscribe_container.radio-container input:checked"
    ).length
  ) {
    copy = "Add subscription to cart";
    document.body.setAttribute("plan-choosen", "subscription");
  }

  if (copy != "") {
    var atcCTA = document.querySelector(
      ".product-form__action-wrapper .product-form--atc-button"
    );

    if (atcCTA.querySelector(".atc-button--text")) {
      atcCTA.querySelector(".atc-button--text").innerHTML = copy;
    } else {
      atcCTA.innerHTML = copy;
    }
  }
}

function FlavorOption() {
    if (document.querySelectorAll('label.options-selection__select-label[data-variant-option-name="Flavor"]').length) {
        document.querySelectorAll('label.options-selection__select-label[data-variant-option-name="Flavor"]')[0].parentNode.classList.add("Flavor")
    }
}

